<div class="table-layout">
    <div class="table-operation">
        <button nButton
            id="front-table-data-turbo-user-data-turbo-share-refresh"
            style="float: right;"
            icon="icon-refresh"
            (click)="updatePermissionTableInfo()">
        </button>
        <n-button-group [relateTable]="dt"
            [items]="[addBtn, removeBtn]">
        </n-button-group>
    </div>
    <div class="table-container">
        <n-data-table #dt
            id="front-table-data-turbo-user-data-turbo-share-table"
            style="height: 4rem;"
            [config]="tableConfig"
            [columnDefs]="tableColumnDefs"
            [rest]="tableRest"
            [(data)]="tableData"
            [(selection)]="selection">
        </n-data-table>
    </div>
</div>
